

export default class TronLogoLinks {

    init(): void {
        this.initTronLogo();
    }

    private initTronLogo() {
        let tronLogoGUID = '';
        try {
            const WebUrl = new URL(window.location.href);
            tronLogoGUID = WebUrl.searchParams.get("tlgd");
            if (!tronLogoGUID) { tronLogoGUID = "" }
        } catch (err) { }

        window.setTimeout(() => this.tronLogoCheckActivate(0, tronLogoGUID), 250);
        
    }

    private tronLogoCheckActivate(tronLogoCheckCounter: number, tronLogoGUID: string) {
        if (window.tronlogo != undefined) {
            if (tronLogoGUID) {
                window.tronlogo.setCurrentLogo(tronLogoGUID);
            }
        } else {
            tronLogoCheckCounter = tronLogoCheckCounter + 1;
            if (tronLogoCheckCounter < 25) {
                window.setTimeout(() => this.tronLogoCheckActivate(0, tronLogoGUID), 250);
            }
        }
    }

}



